import { SectionSummaryInterface, LocationInterface } from '@vendasta/snapshot';

export type SnapshotResult = 'valid' | 'not-ready' | 'not-supported';

export interface TrackingProperties {
  snapshotId?: string;
  category?: string;
}

export interface CurrentInterface {
  snapshot?: CurrentSnapshotInterface;
}

export class Current implements CurrentInterface {
  snapshot: CurrentSnapshotInterface;

  constructor(data: CurrentInterface) {
    this.snapshot = new CurrentSnapshot(data.snapshot);
  }
}

export interface CurrentSnapshotInterface {
  snapshotId?: string;
  created?: Date;
  expired?: Date;
  path?: string;
}

export class CurrentSnapshot implements CurrentSnapshotInterface {
  snapshotId: string;
  created: Date;
  expired: Date;
  path: string;

  constructor(data: CurrentSnapshotInterface) {
    this.snapshotId = data.snapshotId || '';
    this.created = data.created || null;
    this.expired = data.expired || null;
    this.path = data.path || '';
  }
}

export interface SnapshotSummaryInterface {
  snapshotId?: string;
  businessId?: string;
  companyName?: string;
  created?: Date;
  expired?: Date;
  score?: string;
  sections?: SectionSummaryInterface[];
  location?: LocationInterface;
  result?: SnapshotResult;
}

export class Location implements LocationInterface {
  address: string;
  city: string;
  state: string;
  country: string;

  constructor(data: LocationInterface) {
    this.address = data.address || '';
    this.city = data.city || '';
    this.state = data.state || '';
    this.country = data.country || '';
  }
}

export class SnapshotSummary implements SnapshotSummaryInterface {
  snapshotId: string;
  businessId: string;
  companyName: string;
  created: Date;
  expired: Date;
  score: string;
  sections: SectionSummaryInterface[];
  location: LocationInterface;
  result: SnapshotResult;

  constructor(data: SnapshotSummaryInterface, result: SnapshotResult) {
    this.snapshotId = data.snapshotId;
    this.businessId = data.businessId;
    this.companyName = data.companyName;
    this.created = data.created;
    this.expired = data.expired;
    this.score = data.score;
    this.sections = data.sections;
    this.location = new Location(data.location);
    this.result = result;
  }
}
